import { render, staticRenderFns } from "./ClientMaster.vue?vue&type=template&id=3e4d54e5"
import script from "./ClientMaster.vue?vue&type=script&lang=js"
export * from "./ClientMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports